import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  filterScreen: {
    branchList: [],
    branch: null,
    applicationNumberList: [],
    applicationNum: null,
    customerName: "",
    customerId: "",
    applicationDate: "",
    disbursementAmount: "",
    loanAmount: "",
    disburesementDate: null,
    losStatus: "",
    rateOfInterest: "",
    tenure: "",
    emiAmount: "",
    applicationList: [],
    showApplicationListGrid: false,
    selectedFileNumber: "",
    glAccountsMap: {},
    ledgerAccountsList: [],
  },

  touchHandler: {},

  valueIsValid: {},

  filterFieldSelection: {
    showFieldSelection: false,
    checkedFields: [],
    leftFields: [
      "Branch",
      "Application Number",
      "Applicant Name",
      "Customer Id",
      "Application Date",
      "Disbursement Amount",
      "Loan Amount",
      "Disbursement Date",
      "Los Status",
      "Rate of Interest",
      "Tenure",
      "EMI Amount",
    ],
    rightFields: [],
  },

  filterFieldSelectionSaveModel: {
    selectionHeaderKey: 0,
    userName: "",
    selectionType: "",
    createdBy: "",
    lastModifiedBy: "",
    selectionDtl: [],
  },

  screenSelectionSaveModel: {
    selectionHeaderKey: 0,
    userName: "",
    selectionType: "",
    createdBy: "",
    lastModifiedBy: "",
    selectionDtl: [],
  },

  // fieldSelection: {
  //   showFieldSelection: false,
  //   checkedFields: [],
  //   leftFields: [
  //     "Customer Name",
  //     "Customer Id",
  //     "Application Date",
  //     "Disbursement Amount",
  //     "Loan Amount",
  //     "Disbursement Date",
  //     "Los Status",
  //     "Rate of Interest",
  //     "Tenure",
  //     "EMI Amount",
  //   ],
  //   rightFields: [],
  // },

  screenSelection: {
    showScreenSelection: false,
    checked: [],
    left: [
      "Loan Information",
      "Disbursement Details",
      "Fee & Other Charges",
      "NACH Details",
      "Receipt Details",
      "Voucher Details",
      "Return Details",
    ],
    right: [],
  },
};

const CovReducer = createSlice({
  name: "cov",
  initialState: initialState,
  reducers: {
    //Filter Screen Methods
    updateBranchList(state, action) {
      state.filterScreen.branchList = action.payload;
    },
    updateApplicationNumberList(state, action) {
      state.filterScreen.applicationNumberList = action.payload;
    },

    updateselectedFileNumber(state, action) {
      state.filterScreen.selectedFileNumber = action.payload;
    },
    updateshowApplicationListGridValue(state, action) {
      state.filterScreen.showApplicationListGrid = action.payload;
    },

    updateApplicationList(state, action) {
      state.filterScreen.applicationList = action.payload;
    },

    updateBranchValue(state, action) {
      state.filterScreen.branch = action.payload;
      state.valueIsValid.branchIsValid =
        action.payload !== "" && action.payload !== null;
    },

    updateApplicationNumberValue(state, action) {
      state.filterScreen.applicationNum = action.payload;
    },
    updateCustomerName(state, action) {
      state.filterScreen.customerName = action.payload;
    },
    updateCustomerId(state, action) {
      state.filterScreen.customerId = action.payload;
    },
    updateAppDate(state, action) {
      state.filterScreen.applicationDate = action.payload;
    },
    updateDisAmount(state, action) {
      state.filterScreen.disbursementAmount = action.payload;
    },
    updateLoanAmount(state, action) {
      state.filterScreen.loanAmount = action.payload;
    },
    updateDisDate(state, action) {
      state.filterScreen.disburesementDate = action.payload;
    },
    updateLosStatus(state, action) {
      state.filterScreen.losStatus = action.payload;
    },
    updateRateOfInterest(state, action) {
      state.filterScreen.rateOfInterest = action.payload;
    },
    updateTenure(state, action) {
      state.filterScreen.tenure = action.payload;
    },
    updateEmiAmount(state, action) {
      state.filterScreen.emiAmount = action.payload;
    },
    resetBranchValue(state) {
      state.filterScreen.branch = null;
      state.valueIsValid.branchIsValid = false;
    },

    resetApplicationNumberValue(state) {
      state.filterScreen.applicationNum = null;
    },
    resetCustomerName(state) {
      state.filterScreen.customerName = "";
    },
    resetCustomerId(state) {
      state.filterScreen.customerId = "";
    },
    resetAppDate(state) {
      state.filterScreen.applicationDate = "";
    },
    resetDisAmount(state) {
      state.filterScreen.disbursementAmount = "";
    },
    resetLoanAmount(state) {
      state.filterScreen.loanAmount = "";
    },
    resetDisDate(state) {
      state.filterScreen.disburesementDate = null;
    },
    resetLosStatus(state) {
      state.filterScreen.losStatus = "";
    },
    resetRateOfInterest(state) {
      state.filterScreen.rateOfInterest = "";
    },
    resetTenure(state) {
      state.filterScreen.tenure = "";
    },
    resetEmiAmount(state) {
      state.filterScreen.emiAmount = "";
    },
    resetAllScreenFields(state) {
      state.filterScreen.branch = null;
      state.valueIsValid.branchIsValid = false;
      state.filterScreen.applicationNum = null;
      state.filterScreen.customerName = "";
      state.filterScreen.customerId = "";
      state.filterScreen.applicationDate = "";
      state.filterScreen.disbursementAmount = "";
      state.filterScreen.loanAmount = "";
      state.filterScreen.disburesementDate = null;
      state.filterScreen.losStatus = "";
      state.filterScreen.rateOfInterest = "";
      state.filterScreen.tenure = "";
      state.filterScreen.emiAmount = "";
    },
    updateGlAccountsMap(state, action) {
      state.filterScreen.glAccountsMap = action.payload;
    },
    updateLedgerAccountsList(state, action) {
      state.filterScreen.ledgerAccountsList = action.payload;
    },

    //Filter Field Selection Methods
    updateshowFilterFieldSelection(state, action) {
      state.filterFieldSelection.showFieldSelection = action.payload;
    },
    updateFilterFieldSelectionLeftFields(state, action) {
      state.filterFieldSelection.leftFields = action.payload;
    },
    updateFilterFieldSelectionRightFields(state, action) {
      state.filterFieldSelection.rightFields = action.payload;
    },
    updateFilterFieldSelectioncheckedFields(state, action) {
      state.filterFieldSelection.checkedFields = action.payload;
    },
    updateFilterFieldSelectionSaveModel(state, action) {
      state.filterFieldSelectionSaveModel.selectionHeaderKey =
        action.payload.selectionHeaderKey;
      state.filterFieldSelectionSaveModel.selectionType =
        action.payload.selectionType;
      state.filterFieldSelectionSaveModel.userName = action.payload.userName;
      state.filterFieldSelectionSaveModel.selectionDtl =
        action.payload.selectionDtl;
      state.filterFieldSelectionSaveModel.createdBy = action.payload.createdBy;
      state.filterFieldSelectionSaveModel.lastModifiedBy =
        action.payload.lastModifiedBy;
    },

    // //Field Selection Methods
    // updateshowFieldSelection(state, action) {
    //   state.fieldSelection.showFieldSelection = action.payload;
    // },
    // updateFieldSelectionLeftFields(state, action) {
    //   state.fieldSelection.leftFields = action.payload;
    // },
    // updateFieldSelectionRightFields(state, action) {
    //   state.fieldSelection.rightFields = action.payload;
    // },
    // updateFieldSelectioncheckedFields(state, action) {
    //   state.fieldSelection.checkedFields = action.payload;
    // },

    //Screen Selection Methods
    updateshowScreenSelection(state, action) {
      state.screenSelection.showScreenSelection = action.payload;
    },
    updateScreenSelectionLeft(state, action) {
      state.screenSelection.left = action.payload;
    },
    updateScreenSelectionRight(state, action) {
      state.screenSelection.right = action.payload;
    },
    updateScreenSelectionchecked(state, action) {
      state.screenSelection.checked = action.payload;
    },
    updateScreenSelectionSaveModel(state, action) {
      state.screenSelectionSaveModel.selectionHeaderKey =
        action.payload.selectionHeaderKey;
      state.screenSelectionSaveModel.selectionType =
        action.payload.selectionType;
      state.screenSelectionSaveModel.userName = action.payload.userName;
      state.screenSelectionSaveModel.selectionDtl = action.payload.selectionDtl;
      state.screenSelectionSaveModel.createdBy = action.payload.createdBy;
      state.screenSelectionSaveModel.lastModifiedBy =
        action.payload.lastModifiedBy;
    },
  },
});
export const CovReducerAction = CovReducer.actions;
export default CovReducer.reducer;
